import React from 'react'
import { observer } from 'mobx-react-lite'
import { useWidgets } from './WidgetsContext'

interface DelegatorProps {
    id?: string
    htmlId?: string
    documentId?: number
    schemaId?: number
    index?: string
    type?: string
    value?: any
    scope?: string
    onChange?: (id: string, value: any) => void
    className?: string
    errors?: Record<string, any>
    rowColumnCount?: number //the number of columns in the same row
    /** Field ids whose value differs from the version being compared against (Version History). */
    changedFieldIds?: Set<string>
    /** Highlights this field as changed vs. the version being compared against (Version History). */
    isChanged?: boolean
}

const Delegator: React.FC<DelegatorProps> = (({
    type,
    ...props
}) => {

    const components = useWidgets()
    let Component = components.unknown as any // default

    //console.log('DELEGATOR', type, props)

    // Create htmlId including loop index so subForms are unique
    const updatedProps = {...props}
    updatedProps.htmlId = `${props.id}-${props.index??''}`

    if (components[type]) {
        Component = components[type]
    }

    return (
        <Component
            {...updatedProps}
            componentType={type}
        />
    )
})

Delegator.displayName = 'Delegator'

export default Delegator
